export const TemplateFieldsModelsCreate = {
  tabs: [
    {
      entry: { key: 'header1', label: 'MODEL.DATASHEET.HEADERS.HEADER1' },
      children: [
        { entry: { key: 'name', type: 'text', controlType: 'textbox', label: 'MODEL.DATASHEET.FIELDS.NAME', required: true, validationMessage: 'DATASHEET.VALIDATION.REQUIRED.NAME' }}
      ]
    }
  ]
};
